var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOstin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 7,
    viewBox: "0 0 28 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1016_3854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6469 2.8468V6.06243H22.5094V1.64368H24.0625L26.7094 4.6843V1.64368H27.825V6.06243H26.3375L23.6469 2.8468Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5469 1.64368H20.4094V6.06243H21.5469V1.64368Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5656 2.5843V6.06243H16.45V2.5843H14.5687V1.64368H19.4687V2.5843H17.5656Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 0.8125C7.41562 0.8125 7.74374 1.14062 7.74374 1.55625C7.74374 1.97187 7.41562 2.3 6.99999 2.3C6.58437 2.3 6.25624 1.97187 6.25624 1.55625C6.25624 1.14062 6.58437 0.8125 6.99999 0.8125Z",
    fill: "#E43228"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8375 2.5843H3.80625C4.1125 2.5843 4.35312 2.8468 4.35312 3.15305V4.55305C4.35312 4.8593 4.1125 5.1218 3.80625 5.1218H1.8375C1.53125 5.1218 1.29062 4.8593 1.29062 4.55305V3.15305C1.29062 2.8468 1.53125 2.5843 1.8375 2.5843ZM1.1375 1.64368C0.612495 1.64368 0.174995 2.08118 0.174995 2.62805V5.07805C0.174995 5.62493 0.612495 6.06243 1.1375 6.06243H4.55C5.075 6.06243 5.5125 5.62493 5.5125 5.07805V2.62805C5.5125 2.08118 5.075 1.64368 4.55 1.64368H1.1375Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7594 4.53115V5.03427C13.7594 5.40615 13.6062 5.69052 13.3656 5.86552C13.1687 5.99677 13.0156 6.0624 12.6437 6.04052H9.51562C9.25312 6.04052 9.05625 5.99677 8.85937 5.82177C8.64062 5.6249 8.4875 5.38427 8.50937 5.0124V4.6624H9.58125C9.60312 4.9249 9.84375 5.16552 10.1937 5.14365H12.1625C12.425 5.14365 12.6219 4.94677 12.6219 4.70615C12.6219 4.46552 12.4031 4.26865 12.1625 4.26865H9.55937H9.3625C8.90312 4.26865 8.53125 3.89677 8.53125 3.4374V3.2624V2.67177C8.53125 2.2999 8.68437 2.01552 8.94687 1.84052C9.14375 1.70927 9.29687 1.64365 9.66875 1.66552H12.775C13.0375 1.66552 13.2344 1.70927 13.4312 1.88427C13.65 2.08115 13.8031 2.32177 13.7812 2.69365V3.04365H12.7094C12.6875 2.78115 12.4469 2.54052 12.0969 2.5624H10.1281C9.86562 2.5624 9.66875 2.75927 9.66875 2.9999C9.66875 3.24052 9.8875 3.4374 10.1281 3.4374H12.8406H12.9281C13.3875 3.4374 13.7594 3.80927 13.7594 4.26865V4.53115Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1016_3854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 5.6875,
    fill: "white",
    transform: "translate(0 0.59375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOstin);
export default __webpack_public_path__ + "static/media/ostin.c2fc4ace3ab98a6121973ad8e3c8b71b.svg";
export { ForwardRef as ReactComponent };